import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './../../../services/API/auth/auth.service';
import { NotificationServiceService } from './../../../services/notification-service/notification-service.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(private router: Router, private notificationService: NotificationServiceService, private authService: AuthService) {
  }

  canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLogged = this.authService.isLogged();
    const rol = this.authService.userRol();
    if (isLogged && (rol === "admin")) {
      return true;
    }else {
      this.notificationService.openSnackBar('Tu sesión ha expirado');
      this.router.navigate(['/login']);
      return false;
    }
  }

}
